import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";

export default function LegalLayout({ title, children, testId }) {
  return (
    <div className="min-h-screen bg-[#F9F8F6] text-[#1A1C19]" data-testid={testId}>
      <header className="border-b border-[#E5E2DC] bg-[#F9F8F6]/80 backdrop-blur-xl">
        <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="legal-brand-link">
            <img src="/logo.jpg" alt="LLP Zaun&Garten Logo" className="h-10 w-auto rounded-md" data-testid="legal-logo" />
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="flex items-center gap-2 text-sm font-semibold text-[#244A32] hover:text-[#1D3B28] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
          </Link>
        </div>
      </header>
      <main className="px-4 sm:px-8 lg:px-16 max-w-3xl mx-auto py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">{title}</h1>
          <div className="mt-8 space-y-6 text-sm sm:text-base text-[#575953] leading-relaxed">{children}</div>
        </motion.div>
      </main>
      <footer className="border-t border-[#E5E2DC] px-4 sm:px-8 lg:px-16 py-8">
        <p className="max-w-7xl mx-auto text-xs text-zinc-400">
          LLP Zaun&Garten · Inhaber Anatoli Zygankow · Hummelbecker Str. 18 · 32429 Minden
        </p>
      </footer>
    </div>
  );
}
